import { useState } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import H5 from "../Headings/H5Element";
import CollapseContainer from ".";
import { ChevronDown, ChevronUp } from "react-feather";

const CollapseableCard = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(title === 'Asesmen' ? true : false);

  const toggleIsOpen = () => setIsOpen(!isOpen);

  return (
    <>
      <Card>
        <CardHeader
          className="d-flex flex-row-reverse row-cols-6 py-3"
          style={{ cursor: "pointer" }}
          onClick={toggleIsOpen}
        >
          <div className="col">
            <span
              className={
                "d-flex align-content-center cursor-point justify-content-end"
              }
              style={{ cursor: "pointer" }}
            >
              {isOpen ? <ChevronUp /> : <ChevronDown />}
            </span>
          </div>
          <div className={"col-8 text-center"}>
            <H5>{title}</H5>
          </div>
        </CardHeader>
        <CollapseContainer isOpen={isOpen}>
          <CardBody className={"pt-1 py-3"}>{children}</CardBody>
        </CollapseContainer>
      </Card>
    </>
  );
};

export default CollapseableCard;
